import { useState, FormEvent } from 'react';

export default function Reservation() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    date: '',
    guests: '2'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('phone', formData.phone);
      formBody.append('date', formData.date);
      formBody.append('guests', formData.guests);

      const response = await fetch('https://readdy.ai/api/form/d4s0tohjcbkn8g06lm30', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', phone: '', date: '', guests: '2' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="reservation" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
              احجز طاولتك
            </h2>
            <div className="w-24 h-1 bg-teal-600 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600">
              احجز مكانك الآن واستمتع بتجربة طعام استثنائية
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-10 shadow-lg">
            <form id="reservation-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-base font-semibold text-gray-900 mb-3">
                  الاسم الكامل
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="w-full px-5 py-4 text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  placeholder="أدخل اسمك الكامل"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-base font-semibold text-gray-900 mb-3">
                  رقم الهاتف
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  required
                  className="w-full px-5 py-4 text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  placeholder="أدخل رقم هاتفك"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="date" className="block text-base font-semibold text-gray-900 mb-3">
                    التاريخ
                  </label>
                  <input
                    type="date"
                    id="date"
                    name="date"
                    value={formData.date}
                    onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                    required
                    className="w-full px-5 py-4 text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  />
                </div>

                <div>
                  <label htmlFor="guests" className="block text-base font-semibold text-gray-900 mb-3">
                    عدد الأشخاص
                  </label>
                  <select
                    id="guests"
                    name="guests"
                    value={formData.guests}
                    onChange={(e) => setFormData({ ...formData, guests: e.target.value })}
                    required
                    className="w-full px-5 py-4 text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all cursor-pointer"
                  >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                      <option key={num} value={num}>
                        {num} {num === 1 ? 'شخص' : num === 2 ? 'شخصان' : 'أشخاص'}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 text-white px-8 py-5 rounded-xl text-lg font-bold transition-all duration-300 transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'جاري الإرسال...' : 'تأكيد الحجز'}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-6 py-4 rounded-xl text-center">
                  <i className="ri-check-line text-2xl ml-2"></i>
                  تم إرسال طلب الحجز بنجاح! سنتواصل معك قريبًا
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-800 px-6 py-4 rounded-xl text-center">
                  <i className="ri-error-warning-line text-2xl ml-2"></i>
                  حدث خطأ أثناء الإرسال. يرجى المحاولة مرة أخرى
                </div>
              )}
            </form>
          </div>

          <div className="mt-16 bg-gradient-to-r from-teal-50 to-orange-50 rounded-2xl p-8">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
                ساعات العمل
              </h3>
              <div className="space-y-4">
                <div className="flex items-center justify-center gap-3">
                  <i className="ri-restaurant-line text-2xl text-teal-600"></i>
                  <p className="text-lg text-gray-700">
                    <span className="font-bold text-teal-600">بوفيه الفطور المفتوح:</span> يوميًا 6:30 ص - 11:00 ص
                  </p>
                </div>
                <div className="flex items-center justify-center gap-3">
                  <i className="ri-restaurant-2-line text-2xl text-orange-600"></i>
                  <p className="text-lg text-gray-700">
                    <span className="font-bold text-orange-600">الغداء والعشاء:</span> يوميًا 12:00 م - 11:00 م
                  </p>
                </div>
              </div>
              <div className="mt-6 pt-6 border-t border-gray-200">
                <div className="flex items-center justify-center gap-3 text-gray-700">
                  <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                  <span className="text-base">الطابق الأرضي - متاح للضيوف والزوار</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
